import React from 'react';

type NumberInfoProps = {
    value: number,
    name: string,
    loading: boolean,
}

export const NumberInfo = ({
  value,
  name,
  loading,
}:NumberInfoProps) => {

  return (
    <div className={`${loading ? 'animate-pulse' : ''}`}>
      { loading ? (
        <div className='h-20 w-full rounded-md bg-gray-300'>
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center'>
          <p className='p-1 text-center text-4xl font-bold leading-none text-primary-main sm:text-5xl lg:text-6xl'>
            { value }
          </p>
          <p className='text-center text-xs font-bold text-primary-main sm:text-sm'>
            { name }
          </p>
        </div>
      ) }
    </div>
  );
};
